//@flow
import type { InputFormData,DocExtractedData,ReviewAnswer } from './flowTypes'
import {YES,NO} from '../../Utils/variables'

export const getDocExtractedData=(formData: InputFormData)=>{
    const docExtractedData: DocExtractedData = {

    }
    return docExtractedData
}

export const getReviewOutcome=(formData: InputFormData,reviewQuestions: Array<any>)=>{
    let reviewAnswers:Array<ReviewAnswer> = []

    const questions = reviewQuestions.filter(question=> question.mandatory == true)
    questions.map(question=>{
        if (question.questionType == 'singleSelect' && formData[question.elementId]){
            const newReviewAnswer:ReviewAnswer={
                elementId: question.elementId,
                questionText: question.questionText,
                answer: formData[question.elementId],
                subAnswers: []
            }
            reviewAnswers.push(newReviewAnswer)
        }else if (question.questionType == 'yesNo'){
            const yesElement = `${question.elementId}_Yes`
            const noElement = `${question.elementId}_No`

            let newReviewAnswer:ReviewAnswer={
                elementId: question.elementId,
                questionText: question.questionText,
                answer: '',
                subAnswers: []
            }

            if (formData[noElement]){
                newReviewAnswer.answer = NO
                reviewAnswers.push(newReviewAnswer)   
            }else {
                newReviewAnswer.answer = YES
                question.yesSubAnswers.map(subAnswer=>{
                    if (formData[subAnswer.field]){
                        newReviewAnswer.subAnswers.push(subAnswer.field)
                    }
                })
                reviewAnswers.push(newReviewAnswer) 
            }
        }
    })

    return reviewAnswers
}


// WEBPACK FOOTER //
// ./src/redux/kratosec/submitFormData.js